import jMoment from "moment-jalaali";
jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });

export const dateToPersian = date => {
  return jMoment(date).format("jYYYY/jMM/jDD");
};

export const dateTimeToPersian = date => {
  try {
    return jMoment(date).format("jYYYY/jM/jD , HH:mm:ss");
  } catch (ex) { }
};

export const dateToPersian2 = date => {
  try {
    return jMoment(date).format("jYYYY/jM/jD");
  } catch (ex) { }
};

export const toEnglishNumbers = (str) => {
  if (!str) return null;
  return str.replace(/[۰-۹]/g, digit =>
    String.fromCharCode(digit.charCodeAt(0) - 1728)
  );
}
